import {Injectable} from '@nestjs/common';
import {VariantDTO} from './item-variant.dto';
import {Variant} from '../item-variant.entity';

@Injectable()
export class VariantAdapter {
    /**
     * 
     * @param variantDto 
     * @param isUpdate 
     * @returns 
     */

    public convertDtoToEntity( variantDto: VariantDTO, isUpdate: boolean = false): Variant {
        const variant = new Variant();
        variant.variantId=variantDto.variantId;
        variant.variantName=variantDto.variantName;
        variant.isActive=variantDto.isActive==undefined?true:variantDto.isActive;
        if (isUpdate){
            variant.updatedUser = variantDto.updatedUser;
        }else {
            variant.isActive = true;
            variant.createdUser=variantDto.createdUser;
        }
        return variant;
    }
    public convertEntityToDto( variant: Variant): VariantDTO{
        const variantDto = new VariantDTO();
        variantDto.variantId=variant.variantId;
        variantDto.variantName=variant.variantName;
        variantDto.isActive=variant.isActive;
        variantDto.createdAt=variant.createdAt;
        variantDto.createdUser=variant.createdUser;
        variantDto.updatedAt=variant.updatedAt;
        variantDto.updatedUser=variant.updatedUser;
        variantDto.versionFlag=variant.versionFlag;
        return variantDto;
    }
}